import * as yup from "yup";

import { ICreateMerchantDedicatedTopUpAccount } from "../../../interfaces-and-types";

export const createMerchantDedicatedTopUpAccountSchema: yup.SchemaOf<ICreateMerchantDedicatedTopUpAccount> =
  yup
    .object({
      country: yup.string().required("Country is required"),
      currency: yup.string().required("Currency is required"),
      account_reference: yup.string().nullable().optional(),
      // virtual_account_name: yup.string().nullable().optional(),
      preferred_bank_code: yup
        .string()
        .required("Please select a bank to reserve the top-up account"),
      bvn: yup.string().nullable().optional(),
      nin: yup.string().nullable().optional(),
      gateway_code: yup.string().nullable().optional(),
      callback_url: yup.string().nullable().optional(),
    })
    .required();
